var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CookieConsent',{attrs:{"cookie-name":_vm.cookieName,"cookie-value":_vm.cookieValue,"cookies-url":_vm.cookiesUrl,"recommendation-technology-url":_vm.recommendationTechnologyUrl,"personal-data-agreement-url":_vm.personalDataAgreementUrl,"privacy-policy-url":_vm.privacyPolicyUrl,"image":_vm.image,"domain":_vm.domain}})
}
var staticRenderFns = []

export { render, staticRenderFns }